export const GET_ALL_USER_NOTIFICATIONS = 'GET_ALL_USER_NOTIFICATIONS';
export const ADD_NEW_LIVE_NOTIFICATION = 'ADD_NEW_LIVE_NOTIFICATION';
export const SET_UNREAD_NOTIFICATION_COUNT = 'SET_UNREAD_NOTIFICATION_COUNT';
export const GET_USER_ALL_NOTIFICATIONS = 'GET_USER_ALL_NOTIFICATIONS';


